import { configureStore } from "@reduxjs/toolkit";
import serviceReducer from "./serviceSlice";
import headerReducer from "./headerSlice";
import routingSlice from "./routingSlice";
import commonSlice from "./commonSlice";
import leftNavSlice from "./leftNavSlice";

export default configureStore({
  reducer: {
    service: serviceReducer,
    header: headerReducer,
    routing: routingSlice,
    common: commonSlice,
    leftNav: leftNavSlice
  },
});
